import { createRequestHelper } from '@utils/swr'
import { type CampaignCheckoutDisplayFieldsRequest } from '../types/apiRequest'
import { type CampaignCheckoutDisplayFieldsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  mutateAll,
} = createRequestHelper<FortuneApis['get']['campaignCheckoutDisplayFields'], CampaignCheckoutDisplayFieldsResponse, CampaignCheckoutDisplayFieldsRequest>({
  client: 'fortune',
  key: params => params?.code && params.country_code && params.language
    ? `/campaigns/${params.code}/checkout_display_fields?country_code=${params.country_code}&language=${params.language}`
    : null,
  mutateAllMatcher: key => key.startsWith('/campaigns'),
  isImmutable: true,
})

export const useApiCampaignCheckoutDisplayFields = useRequest
export const mutateAllCampaignCheckoutDisplayFields = mutateAll
